module.exports = __webpack_public_path__ + "img/Recurso 4.3def8c14.png";